import instance from '@/api/index.js'
const urlPrefix = '/v1/'
export default {
  getCompany (params){
    return instance({
      method: 'get',
      params: {
        company_name: params,
      },
      url: `${urlPrefix}tik/company_name`,
    })
  },
  // 创建周报
  createReq(data) {
    return instance({
      method: 'post',
      url: `${urlPrefix}requirement`,
      data: data
    })
  },
  getReqs(params) {
    return instance(
      {
        method: 'get',
        params: params,
        url: `${urlPrefix}requirement/list`,
      }
    )
  },
  // 删除需求
  delReqs(id) {
    return instance(
      {
        method: 'delete',
        params: id,
        url:`${urlPrefix}requirement`,
      })
  },
  // 编辑需求
  editReq(id, data) {
    return instance(
      {
        method: 'patch',
        params: id,
        data : data,
        url:`${urlPrefix}requirement`,
      })
  },
  // 获取个人周报
  getSubCompany(params) {
    return instance(
      {
        method: 'get',
        params: {
          company_name: params,
        },
        url: `${urlPrefix}tik/sub_company_name`,
      }
    )
  },
  getReqDetail(id) {
    return instance(
      {
        method: 'get',
        params: {
          id: id,
        },
        url:`${urlPrefix}requirement/detail`,
      })
  },
  getReqList(product_id) {
    return instance(
      {
        method:'get',
        params: {
          product_id: product_id
        },
        url:`${urlPrefix}requirement/req_list`,
      }
    )
  },
  getReqCompanySummary() {
    return instance(
      {
        method: 'get',
        url:`${urlPrefix}requirement/company_summary`,

      }
    )
  },
  getReqProductSummary() {
    return instance(
      {
        method: 'get',
        url:`${urlPrefix}requirement/product_summary`,
      }
    )
  },
  getReqPmSummary() {
    return instance(
      {
        method: 'get',
        url:`${urlPrefix}requirement/pm_summary`,
      }
    )
  },


}
